{

    "dev":{
        "apiUrl":"http://18.117.207.99:5000/api/dev/",
        "apiUrlSecurity": "http://18.117.207.99:5000/api/dev/",
        "wsUrl":"http://18.117.207.99:5000"

    },
    "test":{
        "apiUrl":"https://belleza-cr.com:4000/api/dev/",
        "apiUrlSecurity": "https://belleza-cr.com:4000/api/dev/",
        "wsUrl":"https://belleza-cr.com:4000"

    },
    "local":{
        "apiUrl":"http://localhost:5000/api/dev/",
        "apiUrlSecurity": "http://localhost:5000/api/dev/",
        "wsUrl":"http://localhost:5000"

    }

}
